import React from "react";

class IntroModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        document.getElementById("modal-intro").classList.add("modal-bg");

        if (this.props.accessCookie("graphics")) {
            document.getElementById("modal-intro").classList.add("display-none");
        }
    }

    render() {


        return (
            <div id="modal-intro">
                <div className="modal-container modal-intro" onClick={this.props.stopPropagation}>
                    <div className="modal-content">
                        <h2>Mahjong Space</h2>
                        <p>
                            Welcome to Mahjong Space!  This is a sci-fi themed Mahjong Solitaire!
                        </p>
                        <hr />
                        <form>
                            <h3>Graphics:</h3>
                            <div className="graphics-flex">
                                <div className="graphics-radio-container">
                                    <input type="radio" id="intro-graphics-low" className="graphics-radio" name="graphics" value="low" /><label htmlFor="intro-graphics-low">Low</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="intro-graphics-medium" className="graphics-radio" name="graphics" value="medium" /><label htmlFor="intro-graphics-medium">Medium</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="intro-graphics-high" className="graphics-radio" name="graphics" value="high" defaultChecked /><label htmlFor="intro-graphics-high">High</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="intro-graphics-veryhigh" className="graphics-radio" name="graphics" value="veryhigh" /><label htmlFor="intro-graphics-veryhigh">Very High</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="intro-graphics-ultra" className="graphics-radio" name="graphics" value="ultra" /><label htmlFor="intro-graphics-ultra">Ultra</label>
                                </div>
                            </div>
                            <sub>Higher graphics will use more data and impact performance if you are playing on a mobile device.</sub>
                            <br />
                            <br />

                            <hr />

                            <h3>Cookies</h3>
                            <input type="checkbox" id="intro-accept-cookies" name="cookies" /><label htmlFor="intro-accept-cookies">Accept cookies</label>
                            <br />
                            <sub>Cookies are only used to save your graphics settings and skip this intro when you come back to play again on this device.</sub>
                            <br />
                            <br />
                            <hr />
                            <br />

                            <input type="submit" value="Play!" className="button" data-modalid="modal-intro" onClick={this.props.setSettings} />
                        </form>
                        <br />
                        <h3>
                            Support
                        </h3>
                        <p>
                            This game is provided for free on the internet.  If you wish to donate to support independent game development, you can buy me a space coffee at <a href="https://ko-fi.com/wbrueske">ko-fi.com/wbrueske.</a>
                        </p>
                        <p>
                            Thanks for playing!  Enjoy!
                        </p>
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}

export default IntroModal;